import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type InstructorDetails } from '../modal/instructor';

export const getAllInstructorsAPI = async () => {
  const response = await baseAPI.get<Array<InstructorDetails>>(
    `/custom-form/instructor`,
  );
  return response.data;
};

export const useGetAllInstructors = () => {
  return useQuery({
    queryKey: [KEYS.INSTRUCTORS],
    queryFn: () => getAllInstructorsAPI(),
  });
};
